import { useState } from 'react';
import { Modal } from 'react-bootstrap';

import useOrganizationQuickImportScanMethodsSettings from '../../../hooks/api/organization/useOrganizationQuickImportScanMethodsSettings';
import { BUTTON_TYPE, ButtonGroup } from '../../generic';
import Button from '../../generic/Button';

import QuickImportScanMethodsFields from './QuickImportScanMethodsFields';
import type { ScanMethodSelections } from './types';

import styles from './QuickImportScanMethodsModal.module.less';

type Props = {
  organizationId: number;
  show: boolean;
  onBack: () => void;
  onConfirm: (selections: ScanMethodSelections) => void;
};

/**
 * Modal shell for selecting quick-import scan methods in the non-bulk flow.
 * Delegates state + data fetching to QuickImportScanMethodsFields; tracks the
 * latest selections in local state so the Import button can forward them on click.
 */
const QuickImportScanMethodsModal = (props: Props) => {
  // Gate rendering on data load so the modal doesn't flash a Loader before
  // defaults arrive. React Query dedupes with Fields' own hook call.
  const { data } = useOrganizationQuickImportScanMethodsSettings(
    props.organizationId,
    props.show,
  );

  const [latest, setLatest] = useState<ScanMethodSelections>({
    quickImportVendoredDetectionEnabled: false,
    quickImportSnippetDetectionEnabled: false,
    quickImportShouldSavePreference: false,
  });

  if (!props.show || !data) {
    return null;
  }

  return (
    <Modal show onHide={props.onBack}>
      <Modal.Header>
        <Modal.Title>Scan additional code sources for risk</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <QuickImportScanMethodsFields
          organizationId={props.organizationId}
          enabled={props.show}
          introClassName={styles.subtitleIntro}
          onChange={setLatest}
        />
      </Modal.Body>
      <Modal.Footer className={styles.modalFooter}>
        <ButtonGroup>
          <Button type={BUTTON_TYPE.SECONDARY} onClick={props.onBack}>Back</Button>
          <Button type={BUTTON_TYPE.PRIMARY} onClick={() => props.onConfirm(latest)}>
            Import Projects
          </Button>
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  );
};

export default QuickImportScanMethodsModal;
